export enum ExportTicketPersonalDetails {
  Account = 'Account',
  Admin = 'Admin',
  Agent = 'Agent',
  Billing = 'Billing',
  Certificate = 'Certificate',
  Configuration = 'Configuration',
  Contract = 'Contract',
  File = 'File',
  FinProfile = 'FinProfile',
  Identity = 'Identity',
  Images = 'Images',
  Report = 'Report',
  Risk = 'Risk',
  Sales = 'Sales',
  Statistics = 'Statistics'
}

export enum ExportTicketTransactions {
  Transaction = 'Transaction'
}

export enum ExportTicketDomains {
  PersonalDetails = 'Personal Details',
  Transactions = 'Transactions'
}

export interface ExportTicket {
  uid: string;
  status: ExportTicketStatus;
  typeName: string;
  createdAt: string;
  updatedAt: string;
  retiredAt?: string;
  revNr: string;
  curHash: string;
  prvHash: string;
  data: {
    domains: (ExportTicketPersonalDetails | ExportTicketTransactions)[];
    exportFileName: string;
  };
  histPrevUid: string;
  ownerEntityUid: string;
  ownerUid: string;
}

export interface ExportTicketSchema {
  properties: {
    domains: {
      items: {
        description: string;
        enum: string[];
        type: string;
      };
      type: string;
    };
  };
  type: string;
}

export enum ExportTicketStatus {
  New = 'new',
  Active = 'active',
  Used = 'used',
  Failed = 'failed'
}

export interface ExportTicketMessage {
  exportTicketUID: string;
  fileName: string;
  status: ExportTicketStatus;
  revNr: number;
}
